// extracted by mini-css-extract-plugin
export default {"container":"Privacy_container__jeRmb","privacy":"Privacy_privacy__-ycyx","card":"Privacy_card__MTrsx"};